module.exports = __webpack_public_path__ + "img/f9cf56885dd14ee76d21bff256adcc0a.png";